import script from "./CurrentAddressFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrentAddressFormModal.vue?vue&type=script&setup=true&lang=ts"

import "./CurrentAddressFormModal.vue?vue&type=style&index=0&id=ba657352&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba657352"]])

export default __exports__